import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { bindActionCreators } from "redux";
import "./RadioInput.scss"
import { useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select, InputAdornment, Input, OutlinedInput, TextField } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch } from "react-redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
export default function RadioInput(props: any) {
  const { name, label, data, value, placeholder, handlechange, type, adornmentType, adornmentText } = props;
  const dispatch = useDispatch();
  const {
    freezScreenState,
    alertMessageState,
    setStoreId
  } = bindActionCreators(actionCreators, dispatch);
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, freezScreen } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const [options, setOptions] = useState<any[]>([]);


  const convertStringToArray = (string: string): { value: string, name: string, id: string }[] => {
    const arr = string?.split(',');
    const result: { value: string, name: string, id: string }[] = [];

    arr?.forEach((element, index) => {
      const id = (index + 1).toString();
      result.push({ value: element, name: element, id: id });
    });

    return result;
  };

  useEffect(() => {
    let res = convertStringToArray(data?.values)
    setOptions(res)
  }, [data])




  return (

    <div id="RadioInput" className="">
      <p className="mb-0 label mb-1 familysora600 text-capitalize">{label}</p>
      <FormControl className={`labelParent  ${appState.langValue === "ar" ? " direction-ltr" : "direction-rtl"
}`}  size="small">
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name={name}
          value={value}
          onChange={handlechange}
        >

          {options?.map((v: any, i: any) => {
            return (
              <FormControlLabel key={i} value={v.value} control={<Radio />} label={v.value} />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>

  );
}
